import axios from 'axios';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setMyTickets(state, data) {
      state.list = data;
    },
  },
  actions: {
    fetchFromServer({ commit }, token) {
      axios.get(`/api/tickets/forUser/${token}`)
        .then(response => commit('setMyTickets', response.data))
        .catch(error => console.log(error));
    },
    async fetchTicketQR(context, ticketID) {
      try {
        return axios.get(`/api/tickets/${ticketID}/qr`);
      } catch (error) {
        return console.log(error);
      }
    },
    async buyTicket({ dispatch }, {
      token, entryID, stationFromID, stationToID, onSuccess, onFailure,
    }) {
      const params = {
        token, entryID, stationFromID, stationToID,
      };

      try {
        const response = await axios.post('/api/tickets/buy', params);
        const success = response.data;

        if (success) {
          dispatch('fetchFromServer', token); // odśwież listę biletów
          onSuccess();
        } else {
          onFailure();
        }

        return true;
      } catch (error) {
        console.log(error);
        onFailure();

        return false;
      }
    },
  },
};
